// import Swiper core and required modules
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/virtual";
import "./styles.css";

const Carousel = (props) => {
  if (!props.slides || !props.slides.length) {
    return null;
  }
  return (
    <Swiper
      slidesPerView={props.carouselItems}
      centeredSlides={true}
      spaceBetween={30}
      grabCursor={true}
      pagination={{
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      }}
      style={{ height: "100%" }}
      modules={[Pagination]}
    >
      {props.slides.map((elem, i) => (
        <SwiperSlide key={"slide-" + i}>{elem}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carousel;
